import auction from './auction'
import freight from './freight'
import furniture from './furniture'
import material from './material.js'
import trash from './trash'
// import extra from './extra'

export default {
  name: 'FinancialTariff',
  path: 'tariff',
  meta: {
    label: 'tariff',
    auth: 'tariff'
  },
  component: {
    name: 'Tariff',
    render(c) {
      return c('router-view')
    }
  },
  children: [auction, furniture, material, trash, freight]
}
